import { render, staticRenderFns } from "./FactOption.vue?vue&type=template&id=6236fb41&scoped=true&"
import script from "./FactOption.vue?vue&type=script&lang=ts&"
export * from "./FactOption.vue?vue&type=script&lang=ts&"
import style0 from "./FactOption.vue?vue&type=style&index=0&id=6236fb41&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6236fb41",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})
